// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BCTz","delete":"styles_delete__AbBkC","update":"styles_update__2Uz_I","add":"styles_add__2rHqn"};